import { createApiRef } from '@backstage/core-plugin-api';

const isOperator = (s) => {
  return ["<", "<=", "==", "!=", ">", ">=", "contains"].includes(s);
};
const visitsApiRef = createApiRef({
  id: "homepage.visits"
});

export { isOperator, visitsApiRef };
//# sourceMappingURL=VisitsApi.esm.js.map
